var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnualCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.82769 8.00009C5.82769 10.6401 7.96923 12.7755 10.6092 12.7755C11.0954 12.7755 11.5631 12.7016 12.0062 12.5662V13.7109C12.0062 14.6339 11.2554 15.3847 10.3323 15.3847H2.28923C1.36615 15.3847 0.615383 14.6339 0.615383 13.7109V2.28932C0.615383 1.36625 1.36615 0.615479 2.28923 0.615479H10.3323C11.2554 0.615479 12.0062 1.36625 12.0062 2.28932V3.43394C11.5631 3.29856 11.0954 3.22471 10.6092 3.22471C7.96923 3.22471 5.82769 5.36009 5.82769 8.00009Z",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3846 7.99999C15.3846 10.1538 13.9569 11.9692 12.0062 12.5661C11.5631 12.7015 11.0954 12.7754 10.6092 12.7754C7.96923 12.7754 5.82769 10.64 5.82769 7.99999C5.82769 5.35999 7.96923 3.22461 10.6092 3.22461C11.0954 3.22461 11.5631 3.29846 12.0062 3.43384C13.9569 4.03076 15.3846 5.84615 15.3846 7.99999Z",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6031 8.03068V5.35376",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6031 10.646V9.99365",
    stroke: "#637381",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnualCompliance);
export default __webpack_public_path__ + "static/media/annual-compliance.8cabd3b9295f822f275daf9154ef9076.svg";
export { ForwardRef as ReactComponent };